import React from 'react'
import {Helmet} from 'react-helmet'
import PageTransition from 'gatsby-plugin-page-transitions'

import take from 'lodash/take'
import map from 'lodash/map'

import { Cell, ResponsiveContainer } from '../components/ResponsiveGrid'
import Link from '../components/Link'
import Header from '../components/Header/index'
import { Paragraph } from '../components/Contents'
import CardImage from '../components/CardImage'
import CardText from '../components/CardText'
import AboutMe from '../components/AboutMe'
import BlogPostExcerpt from '../components/BlogPostExcerpt'
import ReadMoreButton from '../components/ReadMoreButton'

const IndexPage = ({ data }) => (<PageTransition>
  <div className="Atrakeur-Page">
    <Helmet>
      <meta charSet="utf-8" />
      <title>Atrakeur: DIY, Modélisme et Web</title>
    </Helmet>
    
    <Header
      contentID="index_title"
      size="large"
    />

    <div className="Atrakeur-Content">
      <ResponsiveContainer className="Atrakeur-Home" white withMargin withPadding>
        <Cell colSpanDesktop="6" colSpanTablet="4" colSpanMobile="4">
          <Paragraph contentID="index_goal" className="Atrakeur-Home-Goal" />
        </Cell>
        <Cell colSpanDesktop="3" colSpanTablet="4" colSpanMobile="4">
          <Link to="/blog/web">
            <CardImage contentID="index_web" size="medium" hoverable/>
          </Link>
        </Cell>
        <Cell colSpanDesktop="3" colSpanTablet="4" colSpanMobile="4">
          <Link to="/blog/diy">
            <CardImage contentID="index_diy" size="medium" hoverable/>
          </Link>
        </Cell>
        { false && <Cell colSpanDesktop="2" colSpanTablet="4" colSpanMobile="4">
          <Link to="/blog/flight">
            <CardImage contentID="index_flight" size="medium" hoverable/>
          </Link>
        </Cell> }
      </ResponsiveContainer>

      <ResponsiveContainer className="Atrakeur-Home" withMarginHor>
        <Cell colSpanDesktop="4" colSpanTablet="4" colSpanMobile="4">
          <Cell white withPadding>
            <Paragraph contentID="index_work" className="Atrakeur-Home-Welcome text-centered" />
          </Cell>
          { map(take(data.allContentfulBlogPost.edges, 2), ({node: post}) => (
            <BlogPostExcerpt post={post} disableMarginHor={true} key={post.id}/>
          ))}
        </Cell>
        <Cell colSpanDesktop="2" colSpanTablet="4" colSpanMobile="4">
          <Cell withPadding white>
            <AboutMe imageContentID="index_about" paragraphContentID="index_about" />
            <ReadMoreButton to='/aboutme'>A propos...</ReadMoreButton>
          </Cell>
        </Cell>
      </ResponsiveContainer>
    </div>
  </div>
</PageTransition>)

export default IndexPage

export const pageQuery = graphql`
query indexBlogPosts {
  allContentfulBlogPost(sort: { fields: [createdAt], order: DESC}) {
    edges {
      node {
        title
        slug
        category {
          title
          slug
        }
        featured {
          id
          resolutions(width: 2048) {
            ...GatsbyContentfulResolutions
          }
        }
        childContentfulBlogPostContentTextNode {
          childMarkdownRemark {
            excerpt(pruneLength: 300)
          }
        }
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/pages/index.js